export default __webpack_public_path__ + "static/media/declined_elite.02880e27.gif";